import React from "react";
import "./Front.css";
import mind from "./mind-matter.png";
import plato from "./plato1.png";
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { Link } from 'react-router-dom';

import Box from '@mui/material/Box';
/**
 * Uses Tailwind CSS for styling
 * Tailwind file is imported in App.css
 */

export default function Front() {

const buttons = [
  <div>
  <Button4 text="Background Bank Interpretation" date="21/09/26" url="background_bank.pdf"/>
</div>,
<div>
  <Button4 text="Theory of Polytypes" date="21/09/26" url="jamie_polytypes.pdf"/>
</div>,
];

  return (
    <div className="app min-h-screen text-blue-200 p-20" style={{ width: "100%", minHeight: "100vh" }}>

      <div className="front-header">
        <nav className="top-links">
          <Link to="/about">About</Link>
          <Link to="/faq">FAQ</Link>
          <a href="mailto:abrhm17@gmail.com">Contact</a>
        </nav>

        <div className="plato-image">
          <img src={plato} alt="" />
        </div>
      </div>

      <div className="front-body">
        <div className="left-list">
          <ButtonGroup
            orientation="vertical"
            aria-label="Vertical button group"
            variant="text"
          >
            {buttons}
          </ButtonGroup>
        </div>

        {/* Right side */}

      </div>
    </div>
  );
}

// function Button({ className, text, url = "#" }) {
//   return (
//     <a
//       href={url}
//       className={`${className} py-3 px-6 text-purple-800 hover:text-purple-900 block rounded text-center shadow flex items-center justify-center leading-snug text-xs transition ease-in duration-150 button-colors`}
//     >
//       {text}
//     </a>
//   );
// }

function Button2({ className, text, url = "#" }) {
     const navigate = useNavigate();
     function handleClick(){
        navigate("/about");
    }

    return (
      <a
      onClick={handleClick}
        className={`${className} enable-pointer py-3 px-6text-purple-800 hover:text-purple-900 block rounded text-center shadow flex items-center justify-center leading-snug text-xs transition ease-in duration-150 button-colors`}
      >
        {text}
      </a>
    );
  }
  function Button3({ text, date, url}) {

   return (
  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
  <Button sx={{ fontWeight: 600 }}
    component={Link}
      to={url}
  >
    {text}
    
  </Button>

  <span
    style={{
      fontSize: "12px",
      opacity: 0.6,
            color: "#64B5F6",
      alignSelf: "flex-end", // 👈 pushes it to the right
    }}
  >
    Updated {date}
  </span>
</div>
   );
 }
   function Button4({ text, date, url}) {

   return (
  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
  <Button sx={{ fontWeight: 600, justifyContent: "flex-start", textAlign: "left" }}
     component="a"
    href={url}
  >
    {text}

  </Button>

  <span
    style={{
      fontSize: "12px",
      opacity: 0.6,
            color: "#64B5F6",
      alignSelf: "flex-end", // 👈 pushes it to the right
    }}
  >
    Updated {date}
  </span>
</div>
   );
 }